import React from 'react'
import { useGlobalFields } from '../../../Hooks/Features/TaskLayout/Fields/useGlobalFields'
import CommonGrid from '../../CommonCompo/CommonGrid/CommonGrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const GlobalFields = ({ filterValues, setFilterValues }) => {

  const { columns, rowData, loader, createField, setCreateField, status } = useGlobalFields({ filterValues, setFilterValues });

  return (
    <div>
      <div className='d-flex justify-content-between gap-1 mb-2'>
        <input className='sk-input-dd w80 mb-0' placeholder='Search Fields...' value={createField?.search} onChange={(e) => setCreateField((prev) => ({ ...prev, search: e?.target?.value }))} />
        {/* <div className='d-flex align-items-center'>
          {status?.map(item => (
            <div key={item?.key} className='d-flex align-items-center'>
              <input name='status' type='radio' id={item?.value} checked={createField?.status === item?.value} value={createField?.status} onChange={() => setCreateField((prev) => ({...prev, status: item?.value}))}/>
              <label htmlFor={item?.value}>{item?.label}</label>
            </div>
          ))}
        </div> */}
        {/* <div className='d-flex gap-2'>
          <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => setCreateField((prev) => ({ ...prev, visible: true }))}><FontAwesomeIcon icon="fa-solid fa-plus" /> Create Field</button>
        </div> */}
      </div>
      <div style={{ height: "calc(100vh - 150px)", overflow: "auto" }}>
        <CommonGrid columns={columns} data={[{id: "all", title: "", children: rowData}]} headerHeight={40} rowHeight={30} loader={loader} />
      </div>
    </div>
  )
}

export default GlobalFields